import { Component, OnInit, ViewChild, ElementRef, NgZone, ChangeDetectorRef} from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';
import { ValidationService } from '../../../services/validation.service';
import { MapsAPILoader, LatLngBoundsLiteral, LatLngLiteral } from 'angular2-google-maps/core';
import { SebmGoogleMap, SebmGoogleMapMarker } from 'angular2-google-maps/core';
import { GoogleMapsAPIWrapper } from 'angular2-google-maps/core/services/google-maps-api-wrapper';


@Component({
    selector: 'app-companyDetails',
    templateUrl: './companyDetails.component.html',
    // styleUrls: ['./dashboard.component.scss']
     providers: [ SharedService,PopupSegmentComponent,ValidationService,GoogleMapsAPIWrapper],

})
export class CompanyDetailsComponent implements OnInit {
    @ViewChild('myInput')
myInputVariable: any;

   @ViewChild("search")
    public searchElementRef: ElementRef;
        @ViewChild(SebmGoogleMap) sebmGoogleMap: SebmGoogleMap;

    objLoaderStatus : boolean = false;
imageFlagUplaod = false;
files : any;
segmentImage : string;
logoUrl : string;
errorMessagePattern = "";
errorMessage = "";
errorMessageAcn = "";
 generalUniForm : FormGroup;
data: any;
acnAbn : string;
name : string;
email : string;
status :string;
contactNo : string;
editFlag = false;
businessAddress : string;
isdCode: string;
stateId: string;
    autocomplete: any;
    searchControl: FormControl;
    googleaddress: string;

    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService,private router: Router,
    private dialogService:DialogService,
            private ngZone: NgZone,
        private cdr: ChangeDetectorRef,
        private mapsAPILoader: MapsAPILoader,
        private gmapsApi: GoogleMapsAPIWrapper,

    ) {
    }


    ngOnInit() {
var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 

      this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });

            this.searchControl = new FormControl();

         var token = this.localstorage.getStorage("token");
var uniId = this.localstorage.getStorage("universityId");
      this.generalUniForm = this.formBuilder.group({
            name: ['', Validators.required],
            contactNo : [''],
                    businessAddress : ['', Validators.required],

            email : ['', Validators.compose([ValidationService.emailValidator])],
            acnAbn : ['', Validators.required]
        });

         this.loaderService.displayLoader(true);
 this.shareService.CallDatawithToken("admin/getAdminDetails", null, token).subscribe((result) => {
    if(result.data){
   console.log(result.data);
this.name = result.data.name;
this.email = result.data.supportEmail;
this.contactNo = result.data.contactNumber;
this.acnAbn = result.data.acnAbn;
this.businessAddress = result.data.businessAddress;
if(result.data.isdCode){
this.isdCode = result.data.isdCode;
}
if(result.data.stateModel){

this.stateId = result.data.stateModel.id;
}
     this.loaderService.displayLoader(false);

    }
         });

    }

    createData(){
       var token = this.localstorage.getStorage("token");
     var data : any ={};
     console.log("this.contactNo"+this.contactNo.trim());
     data.firstname = this.name;
     data.supportEmail = this.email;
     data.email = this.email;
data.contactNo = this.contactNo.trim();
data.abnacn = this.acnAbn;
data.businessAddress = this.businessAddress;
data.isdCode = this.isdCode;
data.stateId = this.stateId
                   this.loaderService.displayLoader(true);

if(this.name.trim() != '' && this.acnAbn.trim() != '' ){
            this.shareService.callApiWithToken("admin/updateAdminDetails", data, token).subscribe((result) => {

            if(result.data ){
            this.showUpdate();
            this.loaderService.displayLoader(false);

            }



            });
    }
    else{
        if(this.name.trim() == ''){
            this.errorMessage = "Name can not be empty";
        }
       
         else if(this.acnAbn.trim() == ''){
            this.errorMessageAcn = "ABN/ACN can not be empty";
        }
     
                                      this.loaderService.displayLoader(false);

    }
    
  setTimeout(() => {
 this.errorMessage = "";
           this.errorMessageAcn = "";
          }, 2000);
   }

LatLngNull(event){
    console.log(event);
}

loadPlaces() {
        this.mapsAPILoader.load().then(() => {
            var options = {
                types: []
            }
            this.autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, options);
            this.autocomplete.addListener("place_changed", () => {
                this.ngZone.run(() => {
                    let place: google.maps.places.PlaceResult = this.autocomplete.getPlace();
                                        this.googleaddress = place.formatted_address;

                    this.businessAddress = place.formatted_address;
                    if (place.geometry === undefined || place.geometry === null) {
                        return;
                    }
                   

                });
            });
        });
    }

   showUpdate() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Company Information', 
                message:'Company Details Updated Successfully',
              data: [], 
            showcancel : false})
                .subscribe((isConfirmed)=>{
                      this.editFlag = false;
  
                });
        }



}



// WEBPACK FOOTER //
// ./src/app/admin/layout/companyDetails/companyDetails.component.ts